import Vue from "vue";
import VuetifyToast from "vuetify-toast-snackbar-ng";

Vue.use(VuetifyToast, {
  x: "center",
  y: "top",
  classes: ["body-2"],
  showClose: true,
  dismissable: true,
  timeout: 5000,
  shorts: {
    info: {
      color: "info",
      icon: "mdi-information",
    },
    success: {
      color: "success",
      icon: "info",
    },
    warn: {
      color: "#fb8c00",
      icon: "mdi-alert",
    },
    error: {
      color: "error",
      icon: "mdi-alert-circle",
    },
  },
});
